import React, { useState, useEffect, useRef, useCallback } from "react";
import { toast } from "sonner";
import { Upload, Trash2, ImageOff } from "lucide-react";
import { api } from "./AuthContext";
import { toAbsUrl } from "../data/ApartmentDataContext";

export default function AdminSettings() {
  const [parkPhoto, setParkPhoto] = useState(null);
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setParkPhoto(data?.parkPhoto || null);
    } catch (e) { /* ignore */ }
  }, []);
  useEffect(() => { load(); }, [load]);

  const onUpload = async (e) => {
    const file = (e.target.files || [])[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      await api.put("/admin/settings", { key: "parkPhoto", value: data.url });
      setParkPhoto(data.url);
      toast.success("Parko nuotrauka atnaujinta");
    } catch (err) {
      toast.error("Nepavyko įkelti nuotraukos");
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  const remove = async () => {
    if (!window.confirm("Pašalinti parko nuotrauką?")) return;
    try {
      await api.put("/admin/settings", { key: "parkPhoto", value: null });
      setParkPhoto(null);
      toast.success("Nuotrauka pašalinta");
    } catch (err) {
      toast.error("Nepavyko pašalinti");
    }
  };

  return (
    <div data-testid="settings-panel" className="space-y-6">
      <h2 className="font-serif text-2xl text-[#1A1A1A]">Vieta ir aplinka</h2>
      <p className="text-sm text-[#52525B]">Įkelkite „Pašešupio parko" nuotrauką — ji bus rodoma svetainės „Vieta" skiltyje.</p>

      <div className="max-w-md border border-[#E4E4E7] rounded-lg overflow-hidden bg-white">
        <div className="w-full aspect-[16/9] bg-[#F5F3EE] flex items-center justify-center overflow-hidden">
          {parkPhoto ? (
            <img src={toAbsUrl(parkPhoto)} alt="Parko nuotrauka" data-testid="settings-park-photo" className="w-full h-full object-cover" />
          ) : (
            <div className="flex flex-col items-center gap-2 text-[#A1A1AA]" data-testid="settings-park-placeholder">
              <ImageOff size={36} strokeWidth={1.2} />
              <span className="text-xs uppercase tracking-widest">Nuotraukos nėra</span>
            </div>
          )}
        </div>
        <div className="flex items-center gap-2 p-3">
          <input ref={fileRef} data-testid="settings-park-upload" type="file" accept="image/*" onChange={onUpload} className="hidden" />
          <button type="button" onClick={() => fileRef.current?.click()} disabled={uploading} data-testid="settings-park-upload-btn" className="inline-flex items-center gap-2 bg-[#1A1A1A] text-white text-xs uppercase tracking-wide px-4 py-2 rounded hover:bg-[#2B2B2B] disabled:opacity-50">
            <Upload size={14} /> {uploading ? "Keliama..." : parkPhoto ? "Pakeisti nuotrauką" : "Įkelti nuotrauką"}
          </button>
          {parkPhoto && (
            <button type="button" onClick={remove} data-testid="settings-park-del" className="inline-flex items-center gap-2 text-red-500 hover:text-red-700 text-xs uppercase tracking-wide px-3 py-2">
              <Trash2 size={14} /> Pašalinti
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
